module.exports = __webpack_public_path__ + "img/ia-visual.4b5edcf6.svg";